import { createRouter, createWebHistory } from 'vue-router';
import { projectAuth } from '@/firebase/config';
import Setup from '@/views/admin/Setup.vue';
import Hlpt from '@/views/Hlpt.vue';
import Login from '@/views/Login.vue';
import NProgress from '@/utils/loading-bar';
// import Welcome from '@/views/Welcome.vue';
// import Home2 from '@/views/Home2.vue';
// import Admin from '@/views/admin/Admin';
// import Content from '@/views/admin/Content.vue';
// import EditArticle from '@/views/admin/EditArticle.vue';
// import Articles from '@/views/admin/Articles.vue';
// import CreateArticle from '@/views/admin/CreateArticle.vue';
// import CreateNewsFlash from '@/views/admin/CreateNewsFlash.vue';
// import EditNewsFlash from '@/views/admin/EditNewsFlash.vue';
// import Categories from '@/views/admin/Categories.vue';
// import ContactForm from '@/views/admin/ContactForm';

// import Statistics from '@/views/admin/Statistics/Statistics';
// import Insights from '@/views/admin/Statistics/Insights';
// import StatsContent from '@/views/admin/Statistics/StatsContent';
// import FailedSearches from '@/views/admin/Statistics/FailedSearches';
// import DeflectedTickets from '@/views/admin/Statistics/DeflectedTickets';
// import NewsFlashReports from '@/views/admin/Statistics/NewsFlashReports';
// import Keywords from '@/views/admin/Statistics/Keywords';
// import Tickets from '@/views/admin/Statistics/Tickets';
// import Tasks from '@/views/admin/Statistics/Tasks';
// import Stats from '@/views/admin/Statistics/Stats';
// import Chats from '@/views/admin/Statistics/Chats';

//import NewsFlash from '@/views/admin/NewsFlash';
// import Account from '@/views/admin/Profile/Account';
// import Profile from '@/views/admin/Profile/Profile';
// import Settings from '@/views/admin/Profile/Settings';
// import Theme from '@/views/admin/Profile/Theme';
// import ChangePassword from '@/views/admin/Profile/ChangePassword';
// import Team from '@/views/admin/Profile/Team';
// import Integrations from '@/views/admin/Profile/Integrations';
// import Language from '@/views/admin/Profile/Language';
// import Contact from '@/views/admin/Contact.vue';

// import Frontend from '@/views/frontend/Frontend.vue';
// import HubHome from '@/views/frontend/HubHome.vue';
// import ArticleDetails from '@/views/frontend/ArticleDetails.vue';
// import ArticleCategoriesDetails from '@/views/frontend/ArticleCategoriesDetails';
// import FrontendNews from '@/views/frontend/FrontendNews.vue';
// import FrontendNewsFlash from '@/views/frontend/FrontendNewsFlash.vue';

// import AdvancedWidget from '@/views/widget/widgetAdvanced/AdvancedWidget';
// import HomeAdvancedDashboard from '@/views/widget/widgetAdvanced/HomeAdvancedDashboard';
// import HomeAdvancedChat from '@/views/widget/widgetAdvanced/HomeAdvancedChat';
// import HomeAdvancedMsg from '@/views/widget/widgetAdvanced/HomeAdvancedMsg';
// import HomeAdvancedHelp from '@/views/widget/widgetAdvanced/HomeAdvancedHelp';
// import HomeAdvancedNews from '@/views/widget/widgetAdvanced/HomeAdvancedNews';
// import HomeAdvancedArticles from '@/views/widget/widgetAdvanced/HomeAdvancedArticles';
// import HomeAdvancedNewsFlash from '@/views/widget/widgetAdvanced/HomeAdvancedNewsFlash';
import Home from '@/views/widget/widgetClassic/Home.vue';
// import HomeAdvanced from '@/views/widget/widgetAdvanced/HomeAdvanced.vue';

import Error404 from '@/views/Error/Error404';
import ResetPassword from '@/views/ResetPassword';
import Invite from '@/views/Invite';
import Preview from '@/views/admin/Preview';

import Forgot from '@/views/Forgot';
import GetModalIntegrationsAgencies from '@/views/GetModalIntegrationsAgencies';

import DefaultIntegrations from '@/views/DefaultIntegrations';
import Thankyou from '@/views/Thankyou';
import store from '../store';
import ScreenShare from '@/views/ScreenShare.vue';
import ReviewForm from '@/views/ReviewForm.vue';
import Joinlink from '@/views/Joinlink.vue';

const default_support_lib_id = process.env.VUE_APP_HLPT_PARENT_SUPPORT_LIB_ID;
const engagements_allowed_lib_ids = [
  process.env.VUE_APP_HLPT_PARENT_SUPPORT_LIB_ID,
  process.env.VUE_APP_DEMO_ACCOUNT_SUPPORT_LIB_ID,
];

function lazyLoad(view) {
  return () => import(`@/views/${view}.vue`);
}
function lazyLoadHub(view) {
  return () => import(`@/views/frontend/${view}.vue`);
}

function lazyLoadAdminProfile(view) {
  return () => import(`@/views/admin/Profile/${view}.vue`);
}

function lazyLoadAdminStats(view) {
  return () => import(`@/views/admin/Statistics/${view}.vue`);
}
function lazyLoadAdminReports(view) {
  return () => import(`@/views/admin/Reports/${view}.vue`);
}
function lazyLoadAdminReportsStatic(view) {
  return () => import(`@/views/admin/Reports-Static/${view}.vue`);
}
function lazyLoadAdmin(view) {
  return () => import(`@/views/admin/${view}.vue`);
}

function lazyLoadAdminSop(view) {
  return () => import(`@/views/admin/Sop/${view}.vue`);
}

function lazyLoadAdminAutomation(view) {
  return () => import(`@/views/admin/Automation/${view}.vue`);
}
function lazyLoadAdminFormbuilder(view) {
  return () => import(`@/views/admin/Formbuilder/${view}.vue`);
}
function lazyLoadAdminCourses(view) {
  return () => import(`@/views/admin/Courses/${view}.vue`);
}
function lazyLoadAdvancedWidget(view) {
  return () => import(`@/views/widget/widgetAdvanced/${view}.vue`);
}
function lazyLoadChat(view) {
  return () => import(`@/views/admin/Chat/${view}.vue`);
}
function lazyLoadAdminFlowbuilder(view) {
  return () => import(`@/views/admin/Flowbuilder/${view}.vue`);
}
function lazyLoadNewsFlashAdmin(view) {
  return () => import(`@/views/admin/NewsFlash/${view}.vue`);
}

function lazyLoadAdminArticles(view) {
  return () => import(`@/views/admin/Articles/${view}.vue`);
}

const requireAuth = (to, from, next) => {
  let style = document.getElementById('customWidgetCss');
  let user = localStorage.getItem('user_id');
  let parent_lib_id = localStorage.getItem('parent_lib_id');
  let demoAccountSupportLibId = process.env.VUE_APP_DEMO_ACCOUNT_SUPPORT_LIB_ID;
  let leadCompanySupportLibId = process.env.VUE_APP_HLPT_PARENT_SUPPORT_LIB_ID;
  // console.log('current user in auth guard: ', user)
  if (!user) {
    const returnUrl = to.fullPath ? `?returnUrl=${encodeURIComponent(to.fullPath)}` : '';
    next(`/login${returnUrl}`);
  } else {
    // console.log('from', to)
    const userPermissions = store.state.userPermissions;
    if (to.name == 'ManageAutomation' && userPermissions.canCreateAndEditAnAutomation == false && userPermissions.canDeleteAnAutomation == false && userPermissions.canViewAutomations == false) {
      next({ name: 'AccessDenied' });
    } else if (to.name === 'SmartQueues' && !userPermissions.canCreateAndEditSmartQueue) {
      next({ name: 'AccessDenied' });
    } else if (to.name === 'Integrations' && !userPermissions.canViewIntegrations) {
      next({ name: 'AccessDenied' });
    } else if (to.name == 'Automation' && userPermissions.canCreateAndEditAnAutomation == false && userPermissions.canDeleteAnAutomation == false && userPermissions.canViewAutomations == false) {
      next({ name: 'AccessDenied' });
    } else if (to.name == 'Formbuilder' && userPermissions?.canViewForms == false) {
      next({ name: 'AccessDenied' });
    } else if ((to.name == 'Reports' || to.matched.some(route => route.name === 'Reports')) && userPermissions?.canViewReports == false) {
      next({ name: 'AccessDenied' });
    } else if (to.name == 'ManageFormbuilder' && userPermissions?.canCreateAndEditForms == false) {
      next({ name: 'AccessDenied' });
    } else if (['Notifications', 'TicketSettings', 'TicketCategories', 'TicketTiers'].includes(to.name) && !userPermissions?.canManageWidgetSettings) {
      next({ name: 'AccessDenied' });
    } else if(['TicketTypes'].includes(to.name) && parent_lib_id) {
      next({ name: 'AccessDenied' });
    } else if (to.name == 'Settings' && !userPermissions?.canManageGeneralAndSecuritySettings) {
      next({ name: 'Account' });
    } else if (['Team', 'TeammatesActivityLogs', 'TeammatePermissions'].includes(to.name) && !userPermissions?.canManageTeammatesSeatsAndPermissions) {
      next({ name: 'AccessDenied' });
    } else if (['Content', 'EditArticle', 'CreateArticle'].includes(to.name) && !userPermissions?.canCreateAndUpdateHelpCenterArticles) {
      next({ name: 'AccessDenied' });
    } else if (['NewsFlash', 'EditNewsFlash', 'CreateNewsFlash'].includes(to.name) && !userPermissions.canCreateAndUpdateNewsArticles) {
      next({ name: 'AccessDenied' });
    } else if (['Courses', 'UpdateCourse', 'CreateCourse'].includes(to.name) && !userPermissions.canCreateAndUpdateCoursesArticles) {
      next({ name: 'AccessDenied' });
    } else if (['Sop', 'updateSop', 'CreateSop'].includes(to.name) && !userPermissions.canCreateAndUpdateSopArticles) {
      next({ name: 'AccessDenied' });
    } else if (to.name == 'ChatInboxClone' && to?.query?.tab == 'queue' && !userPermissions.canTakeChats) {
      next({ name: 'AccessDenied' });
    } else if (to.name == 'ChatInboxClone' && to?.query?.tab == 'chats' && !userPermissions.canSuperviseChats) {
      next({ name: 'AccessDenied' });
    } else if (to.name == 'ChatInboxClone' && to?.query?.tab == 'archives' && !userPermissions.canViewChatArchives) {
      next({ name: 'AccessDenied' });
    } else if (to.name == 'ChatInboxClone' && ['tickets', 'othertickets', 'mentiontickets', 'createdbyyoutickets', 'awaitingreplytickets', 'hlpttickets', 'awaitingreplyhlpttickets'].includes(to?.query?.tab) && !userPermissions.canViewExistingTickets) {
      next({ name: 'AccessDenied' });
    } else if (to.name == 'ChatInboxClone' && !userPermissions.canTakeChats && !userPermissions.canSuperviseChats && !userPermissions.canViewChatArchives && !userPermissions.canViewExistingTickets) {
      next({ name: 'AccessDenied' });
    } else if (to.name == 'GetModalIntegrationsAgencies' && localStorage.getItem('support_Lib_id') !== process.env.VUE_APP_HLPT_PARENT_SUPPORT_LIB_ID) {
      next({ name: 'AccessDenied' });
    } else if (to.name == 'ManageFlowbuilder' && userPermissions?.canCreateAndEditFlows == false) {
      next({ name: 'AccessDenied' });
    } else if (to.name == 'PrioritySupport' && store.state.support_lib_id !== default_support_lib_id) {
      next({ name: 'AccessDenied' });
    } else if (to.name == 'Engagements' && (!engagements_allowed_lib_ids.includes(store.state.support_lib_id) || !userPermissions.canViewModalaiCommonInstructions)) {
      next({ name: 'AccessDenied' });
    } else if (to.name == 'CommonInstructions' && !userPermissions.canViewModalaiCommonInstructions) {
      next({ name: 'AccessDenied' });
    } else if (to.name == 'RewritePrompt' && !userPermissions.canViewModalaiSystemInstructions) {
      next({ name: 'AccessDenied' });
    } else if (to.name == 'Review' && !userPermissions.canViewModalaiCommonInstructions && !userPermissions.canViewModalaiSystemInstructions) {
      next({ name: 'AccessDenied' });
    } else if(['AILogs', 'AIArticles', 'EmailLogs', 'TeammatesActivityLogs', 'CriticalAlerts'].includes(to.name) && localStorage.getItem('support_Lib_id') !== process.env.VUE_APP_HLPT_PARENT_SUPPORT_LIB_ID) {
      next({ name: 'AccessDenied' });
    } else if (to.name == 'KnowledgeGap' && localStorage.getItem('support_Lib_id') !== process.env.VUE_APP_HLPT_PARENT_SUPPORT_LIB_ID) {
      next({ name: 'AccessDenied' });
    } else if (['ManageDocs', 'ManageDocsChunks'].includes(to.name) && !userPermissions.canViewModalaiCustomDocs) {
      next({ name: 'AccessDenied' });
    } else if (['ModalAgents', 'ModalAgentsSetup', 'ModalAgentsManagedSetup', 'ModalAgentSkills', 'ModalAgentSkillSetup', 'ModalAgentCorePrompt', 'ModalAgentConnectionLimits'].includes(to.name) && !userPermissions.canViewModalaiCustomDocs && localStorage.getItem('support_Lib_id') !== process.env.VUE_APP_DEMO_ACCOUNT_SUPPORT_LIB_ID) {
      next({ name: 'AccessDenied' });
    } else if (['ModalAgentsSetup', 'ModalAgentsManagedSetup'].includes(to.name) && userPermissions?.canSubmitModalaiCustomDocs == false && localStorage.getItem('support_Lib_id') !== process.env.VUE_APP_DEMO_ACCOUNT_SUPPORT_LIB_ID) {
      next({ name: 'AccessDenied' });
    } else if (['QueryPresets'].includes(to.name) && ['writer', 'editor'].includes(store.state.agent_role)) {
      next({ name: 'AccessDenied' });
    }
    // else if (to.name == 'SystemInstructions' && !userPermissions.canViewModalaiSystemInstructions) {
    //   next({ name: 'AccessDenied' });
    // } else if (to.name == 'FinalPrompt' && !userPermissions.canViewModalaiCommonInstructions && !userPermissions.canViewModalaiSystemInstructions) {
    //   next({ name: 'AccessDenied' });
    // } 
    else if (['CommonInstructions', 'SystemInstructions', 'FinalPrompt', 'RewritePrompt', 'Review'].includes(to.name) && localStorage.getItem('support_Lib_id') !== process.env.VUE_APP_HLPT_PARENT_SUPPORT_LIB_ID) {
      next({ name: 'AccessDenied' });
    } else if (['TaskTemplate', 'AiTask'].includes(to.name) && (![leadCompanySupportLibId, demoAccountSupportLibId].includes(localStorage.getItem('support_Lib_id')))) {
      next({ name: 'AccessDenied' });
    } else {
      next();
    }
  }
  if (style) {
    style.innerHTML = '';
  }
};

const routes = [
  {
    path: '/defaultIntegrations/:id',
    name: 'DefaultIntegrations',
    //redirect: "/dashboards/landing"
    component: DefaultIntegrations,
  },
  // hub page routes
  {
    path: '/',
    name: 'Frontend',
    component: lazyLoadHub('Frontend'),
    children: [
      {
        path: '',
        name: 'HubHome2',
        component: lazyLoadHub('HubHome'),
      },
      {
        path: ':library_key',
        name: 'HubHome',
        component: lazyLoadHub('HubHome'),
      },
      {
        path: 'courses',
        name: 'HubCourses2',
        component: lazyLoadHub('HubCourses'),
      },
      {
        path: 'courses/:library_key',
        name: 'HubCourses',
        component: lazyLoadHub('HubCourses'),
      },
      {
        path: 'course/:library_key/:id',
        name: 'HubCourseDetails',
        component: lazyLoadHub('HubCourseDetails'),
      },

      {
        path: 'coursestatic/:library_key/:id',
        name: 'HubCourseDetailsStatic',
        component: lazyLoadHub('HubCourseDetails2'),
      },

      {
        path: 'course/:id',
        name: 'HubCourseDetails2',
        component: lazyLoadHub('HubCourseDetails'),
      },

      // {
      //   path: "articlecategories/",
      //   name: "ArticleCategories",
      //   component: ArticleCategories
      // },
      {
        path: 'frontendnewsflash/:library_key/:id',
        name: 'FrontendNewsFlash',
        component: lazyLoadHub('FrontendNewsFlash'),
      },
      {
        path: 'frontendnews/:library_key',
        name: 'FrontendNews',
        component: lazyLoadHub('FrontendNews'),
      },
      {
        path: 'article/details/:library_key/:id',
        name: 'ArticleDetails',
        component: lazyLoadHub('ArticleDetails'),
      },

      {
        path: 'article/details/:id',
        name: 'ArticleDetailsWithoutLibraryKey',
        component: lazyLoadHub('ArticleDetails'),
      },
      // {
      //   path: "/articlecategories/",
      //   name: "ArticleCategories",
      //   component: ArticleCategories
      // },
      // {
      //   path: "/article/details/:library_key/:id",
      //   name: "ArticleDetails",
      //   //redirect: "/dashboards/landing"
      //   component: ArticleDetails
      // },
      {
        path: 'articleCategoriesDetails/:library_key/:id',
        name: 'ArticleCategoriesDetails',
        component: lazyLoadHub('ArticleCategoriesDetails'),
      },
      {
        path: 'articleCategoriesDetails/:id',
        name: 'ArticleCategoriesDetails2',
        component: lazyLoadHub('ArticleCategoriesDetails'),
      },
    ],
  },

  //classic widget routes
  {
    path: '/widget/:library_key/',
    name: 'Home',
    component: Home,
  },

  //advanced widget routes
  {
    path: '/widgetAdvanced/:library_key/',
    name: 'HomeAdvanced',
    component: lazyLoadAdvancedWidget('HomeAdvanced'),
  },

  {
    path: '/advancedWidget/:library_key/',
    name: 'AdvancedWidget',
    component: lazyLoadAdvancedWidget('AdvancedWidget'),
    children: [
      {
        path: '',
        name: 'HomeAdvancedDashboardIndex',
        redirect: { name: 'HomeAdvancedDashboard' }
      },
      {
        path: 'dashboard',
        name: 'HomeAdvancedDashboard',
        component: lazyLoadAdvancedWidget('HomeAdvancedDashboard'),
      },
      {
        path: 'chat',
        name: 'HomeAdvancedChat',
        component: lazyLoadAdvancedWidget('HomeAdvancedChat'),
      },
      {
        path: 'chatmodal',
        name: 'HomeAdvancedModalChat',
        component: lazyLoadAdvancedWidget('HomeAdvancedModalChat'),
      },

      {
        path: 'message',
        name: 'HomeAdvancedMsg',
        component: lazyLoadAdvancedWidget('HomeAdvancedMsg'),
      },
      {
        path: 'help',
        name: 'HomeAdvancedHelp',
        component: lazyLoadAdvancedWidget('HomeAdvancedHelp'),
      },
      {
        path: 'help/:categoryId',
        name: 'HomeAdvancedHelp2',
        component: lazyLoadAdvancedWidget('HomeAdvancedHelp'),
      },
      {
        path: 'news',
        name: 'HomeAdvancedNews',
        component: lazyLoadAdvancedWidget('HomeAdvancedNews'),
      },
      {
        path: 'customlink/:name/:id',
        name: 'HomeAdvancedCustomLink',
        component: lazyLoadAdvancedWidget('HomeAdvancedCustomLink'),
      },
      {
        path: 'articleDetail/:id',
        name: 'HomeAdvancedArticles',
        component: lazyLoadAdvancedWidget('HomeAdvancedArticles'),
      },
      {
        path: 'articleDetail/:id',
        name: 'HomeAdvancedArticlesSearched',
        component: lazyLoadAdvancedWidget('HomeAdvancedArticles'),
      },
      {
        path: 'newsFlashDetail/:id',
        name: 'HomeAdvancedNewsFlash',
        component: lazyLoadAdvancedWidget('HomeAdvancedNewsFlash'),
      },
    ],
  },
  // {
  //   path: '/home2',
  //   name: 'Home2',
  //   //redirect: "/dashboards/landing"
  //   component: Home2,
  // },
  {
    path: '/login',
    name: 'Login',
    //redirect: "/dashboards/landing"
    component: Login,
  },
  {
    path: '/screenshare',
    name: 'ScreenShare',
    component: ScreenShare,
  },
  {
    path: '/screenshare-ended',
    name: 'ScreenshareEnded',
    component: () => import('@/views/ScreenshareEnded.vue'),
  },
  {
    path: '/forgot',
    name: 'Forgot',
    component: Forgot,
  },
  {
    path: '/getmodalIntegrationsagencies',
    name: 'GetModalIntegrationsAgencies',
    component: GetModalIntegrationsAgencies,
    beforeEnter: requireAuth,
  },

  //admin routes

  {
    path: '/google_auth',
    name: 'GoogleAuth',
    component: lazyLoad('GoogleAuth'),
  },
  {
    path: '/admin',
    name: 'Admin',
    component: lazyLoadAdmin('Admin'),
    beforeEnter: requireAuth,
    children: [
      {
        path: '',
        name: 'AdminIndex',
        redirect: () => {
          return localStorage.getItem('user_type') == 'agent'
            ? { name: 'ChatInboxClone', query: { tab: 'inbox' } }
            : { name: 'Content' };
        },
      },
      {
        path: 'accessdenied',
        name: 'AccessDenied',
        component: lazyLoadAdmin('AccessDenied'),
      },
      {
        path: 'content',
        name: 'Content',
        component: lazyLoadAdminArticles('Content'),
        beforeEnter: requireAuth,
      },
      {
        path: 'vault-o',
        name: 'Vault-O',
        component: () => import('@/featuresVaultO/KnowledgeWorkspaceVaultO.vue'),
        beforeEnter: requireAuth,
      },
      {
        path: 'vault',
        name: 'Vault',
        component: () => import('@/featuresVault/VaultPage.vue'),
        beforeEnter: requireAuth,
      },
      {
        path: 'chatinbox',
        name: 'ChatInbox',
        component: lazyLoadAdmin('ChatInbox'),
      },
      {
        path: 'sop',
        name: 'Sop',
        component: lazyLoadAdminSop('Sop'),
      },
      {
        path: 'sop/:id',
        name: 'ViewSop',
        component: lazyLoadAdminSop('ViewSop'),
      },
      {
        path: 'sop/create',
        name: 'CreateSop',
        component: lazyLoadAdminSop('ManageSop'),
      },
      {
        path: 'sop/update/:id',
        name: 'updateSop',
        component: lazyLoadAdminSop('ManageSop'),
      },

      {
        path: 'courses',
        name: 'Courses',
        component: lazyLoadAdminCourses('Courses'),
      },
      {
        path: 'automation',
        name: 'Automation',
        component: lazyLoadAdminAutomation('Automation'),
      },
      {
        path: 'manageautomation/:automation_ref',
        name: 'ManageAutomation',
        component: lazyLoadAdminAutomation('ManageAutomation'),
      },
      {
        path: 'formbuilder',
        name: 'Formbuilder',
        component: lazyLoadAdminFormbuilder('Formbuilder'),
      },
      {
        path: 'manageformbuilder',
        name: 'ManageFormbuilder',
        component: lazyLoadAdminFormbuilder('ManageFormbuilder'),
      },
      {
        path: 'flowbuilder',
        name: 'Flowbuilder',
        component: lazyLoadAdminFlowbuilder('Flowbuilder'),
      },
      {
        path: 'flowbuilder/launchers',
        name: 'FlowbuilderLaunchers',
        component: lazyLoadAdminFlowbuilder('Flowbuilder'),
      },
      {
        path: 'flowbuilder/environments',
        name: 'FlowbuilderEnvironments',
        component: lazyLoadAdminFlowbuilder('Flowbuilder'),
      },
      {
        path: 'flowbuilder/global-styles',
        name: 'FlowbuilderGlobalStyles',
        component: lazyLoadAdminFlowbuilder('Flowbuilder'),
      },
      {
        path: 'flowbuilder/documentation',
        name: 'FlowbuilderDocumentation',
        component: lazyLoadAdminFlowbuilder('Flowbuilder'),
      },
      {
        path: 'manageflowbuilder',
        name: 'ManageFlowbuilder',
        component: lazyLoadAdminFlowbuilder('ManageFlowbuilder'),
      },
      {
        path: 'courses/create/:course_id',
        name: 'CreateCourse',
        component: lazyLoadAdminCourses('ManageCourses'),
      },
      {
        path: 'courses/update/:id/:course_id',
        name: 'UpdateCourse',
        component: lazyLoadAdminCourses('ManageCourses'),
      },
      {
        path: 'inbox',
        name: 'ChatInboxClone',
        component: () => import('@/views/admin/Chat/ChatInboxClone.vue'),
      },

      {
        path: 'newsflash',
        name: 'NewsFlash',
        component: lazyLoadNewsFlashAdmin('NewsFlash'),
        beforeEnter: requireAuth,
      },
      {
        path: 'newsflash/create',
        name: 'CreateNewsFlash',
        component: lazyLoadNewsFlashAdmin('CreateNewsFlash'),
        beforeEnter: requireAuth,
      },
      {
        path: 'newsflash/edit/:id',
        name: 'EditNewsFlash',
        component: lazyLoadNewsFlashAdmin('EditNewsFlash'),
        beforeEnter: requireAuth,
      },
      {
        path: 'preview',
        name: 'Preview',
        component: lazyLoadAdmin('Preview'),
        beforeEnter: requireAuth,
      },
      {
        path: 'article/edit/:id',
        name: 'EditArticle',
        component: lazyLoadAdminArticles('EditArticle'),
        beforeEnter: requireAuth,
      },
      {
        path: 'article/create',
        name: 'CreateArticle',
        component: lazyLoadAdminArticles('CreateArticle'),
        beforeEnter: requireAuth,
      },
      {
        path: 'contactform',
        name: 'ContactForm',
        component: lazyLoadAdmin('ContactForm'),
        beforeEnter: requireAuth,
      },
      {
        path: 'statistic',
        // component: lazyLoadAdminStats('Stats'),
        redirect: '/admin/reports/knowledgebasereport',
        name: 'Stats',
        // beforeEnter: requireAuth,
        children: [
          {
            path: '',
            name: 'statsIndex',
            redirect: '/admin/reports/knowledgebasereport',
          },
          {
            path: 'dashboard',
            name: 'Statistics',
            // component: lazyLoadAdminStats('Statistics'),
            redirect: '/admin/reports/knowledgebasereport',
          },
          {
            path: 'dashboardnew',
            name: 'DashboardNew',
            // component: lazyLoadAdmin('DashboardNew'),
            redirect: '/admin/reports/knowledgebasereport',
          },
          {
            path: 'insights',
            name: 'Insights',
            // component: lazyLoadAdminStats('Insights'),
            redirect: '/admin/reports/knowledgebasereport',
          },
          {
            path: 'content',
            name: 'StatsContent',
            // component: lazyLoadAdminStats('StatsContent'),
            redirect: '/admin/reports/knowledgebasereport',
          },
          {
            path: 'failedSearches',
            name: 'FailedSearches',
            // component: lazyLoadAdminStats('FailedSearches'),
            redirect: '/admin/reports/knowledgebasereport',
          },
          {
            path: 'deflectedTickets',
            name: 'DeflectedTickets',
            // component: lazyLoadAdminStats('DeflectedTickets'),
            redirect: '/admin/reports/knowledgebasereport',
          },
          {
            path: 'tickets',
            name: 'StatsTickets',
            // component: lazyLoadAdminStats('Tickets'),
            redirect: '/admin/reports/knowledgebasereport',
          },
          {
            path: 'keywords',
            name: 'Keywords',
            // component: lazyLoadAdminStats('Keywords'),
            redirect: '/admin/reports/knowledgebasereport',
          },
          {
            path: 'tasks',
            name: 'Tasks',
            // component: lazyLoadAdminStats('Tasks'),
            redirect: '/admin/reports/knowledgebasereport',
          },
          {
            path: 'chats',
            name: 'Chats',
            // component: lazyLoadAdminStats('Chats'),
            redirect: '/admin/reports/knowledgebasereport',
          },
          {
            path: 'newsFlashReports',
            name: 'NewsFlashReports',
            // component: lazyLoadAdminStats('NewsFlashReports'),
            redirect: '/admin/reports/knowledgebasereport',
          },
        ],
      },
      {
        path: 'reports',
        component: lazyLoadAdminReports('Reports'),
        name: 'Reports',
        beforeEnter: requireAuth,
        children: [
          {
            path: '',
            name: 'reportsIndex',
            redirect: '/admin/reports/supportoverview',
          },
          {
            path: 'overview',
            name: 'Overview',
            component: lazyLoadAdminReports('Overview'),
          },
          {
            path: 'allreports',
            name: 'AllReports',
            component: lazyLoadAdminReports('AllReports'),
          },
          {
            path: 'yourreports',
            name: 'YourReports',
            component: lazyLoadAdminReports('YourReports'),
          },
          {
            path: 'topics',
            name: 'Topics',
            component: lazyLoadAdminReports('Topics'),
          },
          {
            path: 'suggestions',
            name: 'Suggestions',
            component: lazyLoadAdminReports('Suggestions'),
          },
          {
            path: 'newreport',
            name: 'NewReport',
            component: lazyLoadAdminReports('NewReport'),
          },

          {
            path: 'supportoverview',
            name: 'SupportOverview',
            component: lazyLoadAdminReports('SupportOverview'),
          },
          {
            path: 'conversations',
            name: 'Conversations',
            component: lazyLoadAdminReports('Conversations'),
          },
          {
            path: 'aiagent',
            name: 'AiAgent',
            component: lazyLoadAdminReports('AiAgent'),
          },
          {
            path: 'customersatisfaction',
            name: 'CustomerSatisfaction',
            component: lazyLoadAdminReports('CustomerSatisfaction'),
          },
          {
            path: 'supporttickets',
            name: 'SupportTickets',
            component: lazyLoadAdminReports('SupportTickets'),
          },
          {
            path: 'chatsupport',
            name: 'ChatSupport',
            component: lazyLoadAdminReports('ChatSupport'),
          },
          {
            path: 'knowledgebasereport',
            name: 'KnowledgebaseReport',
            component: lazyLoadAdminReports('KnowledgebaseReport'),
          },
          {
            path: ':id',
            name: 'CustomReport',
            component: lazyLoadAdminReports('CustomReport'),
          },
          {
            path: 'testinggrid',
            name: 'TestingGrid',
            component: lazyLoadAdminReports('TestingGrid'),
          },
        ],
      },
      /// static
      {
        path: 'reportsstatic',
        component: lazyLoadAdminReportsStatic('ReportsStatic'),
        name: 'ReportsStatic',
        beforeEnter: requireAuth,
        children: [
          {
            path: '',
            name: 'reportsstaticIndex',
            redirect: '/admin/reportsstatic/conversationsstatic',
          },
          {
            path: 'supportoverviewstatic',
            name: 'SupportOverviewStatic',
            component: lazyLoadAdminReportsStatic('SupportOverviewStatic'),
          },
          {
            path: 'allreportsstatic',
            name: 'AllReportsStatic',
            component: lazyLoadAdminReportsStatic('AllReportsStatic'),
          },
          {
            path: 'yourreportsstatic',
            name: 'YourReportsStatic',
            component: lazyLoadAdminReportsStatic('YourReportsStatic'),
          },
          {
            path: 'topicsstatic',
            name: 'TopicsStatic',
            component: lazyLoadAdminReportsStatic('TopicsStatic'),
          },
          {
            path: 'suggestionsstatic',
            name: 'SuggestionsStatic',
            component: lazyLoadAdminReportsStatic('SuggestionsStatic'),
          },

          {
            path: 'conversationsstatic',
            name: 'ConversationsStatic',
            component: lazyLoadAdminReportsStatic('ConversationsStatic'),
          },
          {
            path: 'customersatisfactionstatic',
            name: 'CustomerSatisfactionStatic',
            component: lazyLoadAdminReportsStatic('CustomerSatisfactionStatic'),
          },
          {
            path: 'supportticketsstatic',
            name: 'SupportTicketsStatic',
            component: lazyLoadAdminReportsStatic('SupportTicketsStatic'),
          },
          {
            path: 'chatsupportstatic',
            name: 'ChatSupportStatic',
            component: lazyLoadAdminReportsStatic('ChatSupportStatic'),
          },
          {
            path: 'csatformstatic',
            name: 'CsatFormStatic',
            component: lazyLoadAdminReportsStatic('CsatFormStatic'),
          },
        ],
      },
      {
        path: 'profile',
        component: lazyLoadAdminProfile('Profile'),
        name: 'Profile',
        beforeEnter: requireAuth,
        children: [
          {
            path: '',
            name: 'ProfileIndex',
            redirect: '/admin/profile/account',
          },
          {
            path: 'account',
            name: 'Account',
            component: lazyLoadAdminProfile('Account'),
            beforeEnter: requireAuth,
          },
          {
            path: 'onboardingdashboard',
            name: 'OnboardingDashboard',
            component: lazyLoadAdminProfile('OnboardingDashboard'),
            beforeEnter: requireAuth,
          },
          {
            path: 'settings',
            name: 'Settings',
            component: lazyLoadAdminProfile('Settings'),
            beforeEnter: requireAuth,
          },
          {
            path: 'prioritysupport',
            name: 'PrioritySupport',
            component: lazyLoadAdminProfile('PrioritySupport'),
            beforeEnter: requireAuth,
          },
          {
            path: 'theme',
            name: 'Theme',
            component: lazyLoadAdminProfile('Theme'),
            beforeEnter: requireAuth,
          },
          {
            path: 'tickets',
            name: 'Tickets',
            component: lazyLoadAdminProfile('Tickets'),
            beforeEnter: requireAuth,
          },
          {
            path: 'changePassword',
            name: 'ChangePassword',
            component: lazyLoadAdminProfile('ChangePassword'),
            beforeEnter: requireAuth,
          },
          {
            path: 'teammates',
            name: 'Team',
            component: lazyLoadAdminProfile('Team'),
            beforeEnter: requireAuth,
          },
          {
            path: 'teamlogs',
            name: 'TeammatesActivityLogs',
            component: lazyLoadAdminProfile('TeammatesActivityLogs'),
            beforeEnter: requireAuth,
          },
          {
            path: 'emaillogs',
            name: 'EmailLogs',
            component: lazyLoadAdminProfile('EmailLogs'),
            beforeEnter: requireAuth,
          },
          {
            path: 'ailogs',
            name: 'AILogs',
            component: lazyLoadAdminProfile('AILogs'),
            beforeEnter: requireAuth,
          },
          {
            path: 'aitasks',
            name: 'AiTask',
            component: lazyLoadAdminProfile('AiTask'),
            beforeEnter: requireAuth,
          },
          {
            path: 'criticalalerts',
            name: 'CriticalAlerts',
            component: lazyLoadAdminProfile('CriticalAlerts'),
            beforeEnter: requireAuth,
          },
          {
            path: 'knowledgegap',
            name: 'KnowledgeGap',
            component: lazyLoadAdminProfile('KnowledgeGap'),
            beforeEnter: requireAuth,
          },
          {
            path: 'managedocs',
            name: 'ManageDocs',
            component: lazyLoadAdminProfile('ManageDocs'),
            beforeEnter: requireAuth,
          },
          {
            path: 'managedocschunks',
            name: 'ManageDocsChunks',
            component: lazyLoadAdminProfile('ManageDocsChunks'),
            beforeEnter: requireAuth,
          },
          {
            path: 'modalagents',
            name: 'ModalAgents',
            component: lazyLoadAdminProfile('ModalAgents'),
            beforeEnter: requireAuth,
          },
          {
            path: 'modalagentssetup',
            name: 'ModalAgentsSetup',
            component: lazyLoadAdminProfile('ModalAgentsSetup'),
            beforeEnter: requireAuth,
          },
          {
            path: 'modalagentsmanagedsetup',
            name: 'ModalAgentsManagedSetup',
            component: lazyLoadAdminProfile('ModalAgentsManagedSetup'),
            beforeEnter: requireAuth,
          },
          {
            path: 'modalagentskills',
            name: 'ModalAgentSkills',
            component: lazyLoadAdminProfile('ModalAgentSkills'),
            beforeEnter: requireAuth,
          },
          {
            path: 'modalagentskillsetup',
            name: 'ModalAgentSkillSetup',
            component: lazyLoadAdminProfile('ModalAgentSkillSetup'),
            beforeEnter: requireAuth,
          },
          {
            path: 'modalagentcoreprompt',
            name: 'ModalAgentCorePrompt',
            component: lazyLoadAdminProfile('ModalAgentCorePrompt'),
            beforeEnter: requireAuth,
          },
          {
            path: 'modalagentconnectionlimits',
            name: 'ModalAgentConnectionLimits',
            component: lazyLoadAdminProfile('ModalAgentConnectionLimits'),
            beforeEnter: requireAuth,
          },
          {
            path: 'aiarticles',
            name: 'AIArticles',
            component: lazyLoadAdminProfile('AIArticles'),
            beforeEnter: requireAuth,
          },
          {
            path: 'permissions',
            name: 'TeammatePermissions',
            component: lazyLoadAdminProfile('TeammatePermissions'),
            beforeEnter: requireAuth,
          },

          {
            path: 'integrations',
            name: 'Integrations',
            component: lazyLoadAdminProfile('Integrations'),
            beforeEnter: requireAuth,
          },
          {
            path: 'ticketsettings',
            name: 'TicketSettings',
            component: lazyLoadAdminProfile('TicketSettings'),
            beforeEnter: requireAuth,
          },
          {
            path: 'tickettypes',
            name: 'TicketTypes',
            component: lazyLoadAdminProfile('TicketTypes'),
            beforeEnter: requireAuth,
          },
          {
            path: 'notifications',
            name: 'Notifications',
            component: lazyLoadAdminProfile('Notifications'),
            beforeEnter: requireAuth,
          },
          {
            path: 'smartqueues',
            name: 'SmartQueues',
            component: lazyLoadAdminProfile('SmartQueues'),
            beforeEnter: requireAuth,
          },
          {
            path: 'ticketcategories',
            name: 'TicketCategories',
            component: lazyLoadAdminProfile('TicketCategories'),
            beforeEnter: requireAuth,
          },
          {
            path: 'tickettiers',
            name: 'TicketTiers',
            component: lazyLoadAdminProfile('TicketTiers'),
            beforeEnter: requireAuth,
          },
          {
            path: 'language',
            name: 'Language',
            component: lazyLoadAdminProfile('Language'),
            beforeEnter: requireAuth,
          },
          {
            path: 'commoninstructions',
            name: 'CommonInstructions',
            component: lazyLoadAdminProfile('CommonInstructions'),
            beforeEnter: requireAuth,
          },
          {
            path: 'rewriteprompt',
            name: 'RewritePrompt',
            component: lazyLoadAdminProfile('RewritePrompt'),
            beforeEnter: requireAuth,
          },
          {
            path: 'review',
            name: 'Review',
            component: lazyLoadAdminProfile('Review'),
            beforeEnter: requireAuth,
          },
          {
            path: 'systeminstructions',
            name: 'SystemInstructions',
            component: lazyLoadAdminProfile('SystemInstructions'),
            beforeEnter: requireAuth,
          },
          {
            path: 'finalprompt',
            name: 'FinalPrompt',
            component: lazyLoadAdminProfile('FinalPrompt'),
            beforeEnter: requireAuth,
          },
          // {
          //   path: 'copilot',
          //   name: 'Copilot',
          //   component: lazyLoadAdminProfile('Copilot'),
          //   beforeEnter: requireAuth,
          // },
          // {
          //   path: 'composer',
          //   name: 'Composer',
          //   component: lazyLoadAdminProfile('Composer'),
          //   beforeEnter: requireAuth,
          // },
          {
            path: 'quickprompts',
            name: 'QuickPrompts',
            component: lazyLoadAdminProfile('QuickPrompts'),
            beforeEnter: requireAuth,
          },
          {
            path: 'querypresets',
            name: 'QueryPresets',
            component: lazyLoadAdminProfile('QueryPresets'),
            beforeEnter: requireAuth,
          },
          {
            path: 'campaigns',
            name:'Engagements',
            component: lazyLoadAdminProfile('Engagements'),
            beforeEnter: requireAuth,
          },
          {
            path: 'tasktemplate',
            name: 'TaskTemplate',
            component: lazyLoadAdminProfile('TaskTemplate'),
            beforeEnter: requireAuth,
          },
        ],
      },
    ],
  },

  {
    path: '/contact',
    name: 'Contact',
    component: lazyLoadAdmin('Contact'),
    beforeEnter: requireAuth,
  },
  // {
  //   path: '/admin/setup',
  //   name: 'Setup',
  //   component: Setup,
  //   beforeEnter: requireAuth,
  // },
  // {
  //   path: '/admin/articles',
  //   name: 'Articles',
  //   component: Articles,
  //   beforeEnter: requireAuth,
  // },
  // {
  //   path: '/admin/categories',
  //   name: 'Categories',
  //   component: Categories,
  //   beforeEnter: requireAuth,
  // },

  {
    path: '/Invite',
    name: 'Invite',
    component: Invite,
  },
  {
    path: '/reviewForm',
    name: 'ReviewForm',
    component: ReviewForm,
  },
  {
    path: '/join',
    name: 'Joinlink',
    component: Joinlink,
  },
  {
    path: '/resetpassword',
    name: 'ResetPassword',
    component: ResetPassword,
  },

  //ContactForm

  {
    path: '/:catchAll(.*)',
    name: 'Error404',
    component: Error404,
  },
  {
    path: '/hlpt',
    name: 'Hlpt',
    component: Hlpt,
  },
  {
    path: '/thank-you',
    name: 'Thankyou',
    component: Thankyou,
  },
];
let history = process.env.NODE_ENV !== 'EC2' ? process.env.BASE_URL : '';
const router = createRouter({
  history: createWebHistory(history),
  routes,
  linkActiveClass: 'active',
});

// router.beforeEach((to, from, next) => {
//   NProgress.start();

//   // 1. Remove Google's classes from <html> and <body>
//   document.documentElement.classList.remove('translated-ltr', 'translated-rtl');
//   document.body.classList.remove('goog-te-status-positioned');
  
//   // 2. Remove the Google Translate top banner if it exists
//   const banner = document.querySelector('.goog-te-banner-frame');
//   if (banner) banner.remove();

//   // 3. Reset body top position
//   document.body.style.top = '0px';

//   next();
// });

// Stop the progress bar after navigation is complete
router.afterEach(() => {
  NProgress.done();
});

export default router;
